export const preloadImage = (url: string) => {
  return new Promise((resolve, reject) => {
    const image: HTMLImageElement = new Image();
    image.src = url;
    image.onload = resolve;
    image.onerror = reject;
  });
};
